<template>
  <v-container>
    <v-card>
      <v-tabs
        v-model="tab"
      >
        <v-tabs-slider color="accent" />
        <v-tab
          v-for="(sType, n) in serverTypes"
          :key="`server-type-${n}`"
        >
          {{ sType }}
        </v-tab>
      </v-tabs>
      <v-tabs-items
        v-model="tab"
        class="pa-3"
      >
        <v-tab-item
          key="servers-0"
        >
          <paused-server-alerts-table
            :servers="web"
            type="web"
          />
        </v-tab-item>
        <v-tab-item
          key="servers-1"
        >
          <paused-server-alerts-table
            :servers="csr"
            type="csr"
          />
        </v-tab-item>
        <v-tab-item
          key="servers-2"
        >
          <paused-server-alerts-table
            :servers="imq"
            type="imq"
          />
        </v-tab-item>
        <v-tab-item
          key="servers-3"
        >
          <paused-server-alerts-table
            :servers="win"
            type="win"
          />
        </v-tab-item>
        <v-tab-item
          key="servers-4"
        >
          <paused-server-alerts-table
            :servers="itm"
            type="itm"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
  export default {
    name: 'ServerPausedAlerts',
    props: {
      web: Array,
      csr: Array,
      imq: Array,
      win: Array,
      itm: Array,
    },
    data () {
      return {
        tab: 0,
        serverTypes: ['web', 'csr', 'imq', 'win', 'itm'],
      }
    },
  }
</script>